import { useFormikContext } from 'formik'
import PropTypes from 'prop-types'

import AssignedItemsButton from 'components/AssignedItemsButton'

const AddModifierGroups = ({ id, setFormStep, isItemModifier }) => {
  const { values } = useFormikContext()

  const handleClick = () => setFormStep('modifiersDrawer')

  if (isItemModifier) {
    return null
  }

  return (
    <section
      className="content-wrapper -flags-wrapper -block"
      id={id}
    >
      <h3 id={id} className="header-title">
        Add Modifier Groups
      </h3>
      <p className="modal-paragraph font-size-smaller">
        The modifier groups you choose for this item will modify how
        it appears and functions on POS, Kiosk, and Mobile Ordering.
      </p>
      <div className="text-field padding-top-sm">
        <AssignedItemsButton
          handleClick={handleClick}
          label="Select Modifier Groups"
          assignedItems={values?.modifierMinMax?.length}
        />
      </div>
    </section>
  )
}

AddModifierGroups.propTypes = {
  id: PropTypes.string,
  setFormStep: PropTypes.func,
  isItemModifier: PropTypes.bool,
}

export default AddModifierGroups
